


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { AvailabilityViewModel } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { getAvailabilityHeaders } from '@/views/account/availability/availability';
import {availabilityService} from '@/shared';

@Component({
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
    },
})
export default class StoreAvailabilityPage extends Base {
    public headers: VHeaders[] = getAvailabilityHeaders(this);
    public pagedAvailabity: AvailabilityViewModel[] = [];
    public pagination = new PaginationModel('storeName');
    public loading: boolean = false;
    public tenantId: string = '';
    public enterpriseId: string = '';
    public actions: any[] = [];

    public searched: boolean = false;
    public deleted: boolean = false;

    public mounted() {
        this.actions = [{
            type: 'link',
            icon: 'fas fa-edit',
            title: this.$t('availability.availabilityGridHeaders.gridAction.edit') as string,
            action: (model: AvailabilityViewModel, storeid: string) => {
                return {
                    name: 'availability.edit',
                };
            },
        }];
        this.getAvailability();
    }
    public async getAvailability(): Promise<void> {
        try {
            this.loading = true;
            const availability = await availabilityService.getAvailabilities();
            this.pagedAvailabity = availability.results;
            this.pagination.totalItems = availability.total;
        } finally {
            this.loading = false;
        }
    }
    public updatePaging(paging: any) {
        this.pagination = paging;
    }
}
